import React, { useState, useEffect } from "react";
import "./UserSettings.css";
import { useAuthStore } from "../../../services/useAuthStore";
import { api } from "../../../services/api";

const UserSettings = () => {
  const { preferences, setAuthFromMe } = useAuthStore();
  

  const [dailySummary, setDailySummary] = useState(false);
  const [botFailureAlert, setBotFailureAlert] = useState(false);
  const [theme, setTheme] = useState("light");
  const [isUpdating, setIsUpdating] = useState(false);


  useEffect(() => {
    if (preferences) {
      setDailySummary(preferences.receive_daily_summary || false);
      setBotFailureAlert(preferences.receive_bot_failure_alert || false);
      setTheme(preferences.preferred_theme || "light");
    }
  }, [preferences]);


  const updatePreferences = async (updates) => {
    setIsUpdating(true);
    try {
      const response = await api.put("/api/auth/me/preferences", updates);
      
     
      const meResponse = await api.get("/api/auth/me");
      setAuthFromMe(meResponse.data);
      
      console.log("Preferências atualizadas com sucesso:", response.data);
    } catch (error) {
      console.error("Erro ao atualizar preferências:", error);
   
      if (preferences) {
        setDailySummary(preferences.receive_daily_summary || false);
        setBotFailureAlert(preferences.receive_bot_failure_alert || false);
        setTheme(preferences.preferred_theme || "light");
      }
    } finally {
      setIsUpdating(false);
    }
  };


  const handleDailySummaryChange = (e) => {
    const newValue = e.target.checked;
    setDailySummary(newValue);
    updatePreferences({ receive_daily_summary: newValue });
  };


  const handleBotFailureAlertChange = (e) => {
    const newValue = e.target.checked;
    setBotFailureAlert(newValue);
    updatePreferences({ receive_bot_failure_alert: newValue });
  };


  const handleThemeChange = (e) => {
    const newValue = e.target.value;
    setTheme(newValue);
    updatePreferences({ preferred_theme: newValue });
  };

  return (
    <div className="co-section">
      <h2>Perfil do usuário</h2>
      <p className="co-section-subtitle">
        Afeta:{" "}
        <strong>
          todas as telas para o usuário logado (preferências pessoais).
        </strong>
      </p>

      <div className="co-group">
        <h3>Dados básicos</h3>

        <div className="co-field-row">
          <div className="co-field">
            <label>Nome completo</label>
            <input type="text" placeholder="Rafael Steffens" />
          </div>

          <div className="co-field">
            <label>E-mail de login</label>
            <input type="email" placeholder="voce@empresa.com.br" />
          </div>
        </div>

        <div className="co-field-row">
          <div className="co-field">
            <label>Cargo / função</label>
            <input type="text" placeholder="CEO, Gestor, Coordenador, SDR..." />
          </div>

          <div className="co-field">
            <label>Foto / Avatar</label>
            <button className="co-btn-outline">Enviar nova foto</button>
          </div>
        </div>
      </div>

      <div className="co-group">
        <h3>Preferências pessoais</h3>

        <div className="co-field-row">
          {/* <div className="co-field">
            <label>Notificações por e-mail</label>

            <div className="co-toggle-row">
              <label className="co-toggle">
                <input 
                  type="checkbox" 
                  checked={dailySummary}
                  onChange={handleDailySummaryChange}
                  disabled={isUpdating}
                />
                <span className="co-toggle-slider"></span>
              </label>
              <span className="co-toggle-label">
                Receber resumo diário de automações e SLAs críticos
              </span>
            </div>

            <div className="co-toggle-row">
              <label className="co-toggle">
                <input 
                  type="checkbox"
                  checked={botFailureAlert}
                  onChange={handleBotFailureAlertChange}
                  disabled={isUpdating}
                />
                <span className="co-toggle-slider"></span>
              </label>
              <span className="co-toggle-label">
                Receber alerta quando um bot falhar mais de X vezes por dia
              </span>
            </div>
          </div> */}

          <div className="co-field">
            <label>Layout preferido</label>
            <select 
              value={theme}
              onChange={handleThemeChange}
              disabled={isUpdating}
            >
              <option value="dark">Dark (recomendado)</option>
              <option value="light">Claro</option>
            </select>
            <p className="co-hint">
              Apenas visual. Não impacta outros usuários da conta.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;

